import { STATUS_ORDER, STATUS_LABEL } from "@/lib/format";
import { Check } from "lucide-react";

export default function StatusStepper({ status, onChange }) {
  const idx = STATUS_ORDER.indexOf(status);

  return (
    <div className="flex items-center w-full" data-testid="status-stepper">
      {STATUS_ORDER.map((s, i) => {
        const isDone = i < idx;
        const isActive = i === idx;
        return (
          <div key={s} className="flex items-center flex-1 last:flex-none">
            <button
              type="button"
              onClick={() => onChange && onChange(s)}
              data-testid={`stepper-${s}`}
              className={`flex flex-col items-center gap-2 ${onChange ? "cursor-pointer group" : ""}`}
            >
              <div
                className={`h-8 w-8 rounded-full flex items-center justify-center text-xs font-medium border transition-colors ${
                  isActive
                    ? "bg-[#16202B] border-[#16202B] text-white"
                    : isDone
                    ? "bg-emerald-600 border-emerald-600 text-white"
                    : "bg-white border-[#D9CDB5] text-stone-400"
                }`}
              >
                {isDone ? <Check className="h-4 w-4" strokeWidth={2.5} /> : i + 1}
              </div>
              <span
                className={`text-[10px] uppercase tracking-wider font-semibold ${
                  isActive ? "text-[#16202B]" : isDone ? "text-emerald-700" : "text-stone-400"
                }`}
              >
                {STATUS_LABEL[s].split(" ")[0]}
              </span>
            </button>
            {i < STATUS_ORDER.length - 1 && (
              <div
                className={`flex-1 h-px mx-2 -mt-5 ${
                  i < idx ? "bg-emerald-500" : "bg-stone-200"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
